<template>
    <LoanRequestsDetails />
</template>

<script>
    export default {
        name: "loan-request-details",
        components: {
            'LoanRequestsDetails': () => import("../components/LoanDetails")
        },
        data() {
            return {

            }
        },
        created() {

        },
        mounted:function(){
        },
        methods: {
        }
    }
</script>

<style scoped>
    
</style>